




















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ModalMessage extends Vue {
  @Prop({ default: "【確認】" }) title!: string
  @Prop({ default: "メッセージ" }) message!: string

  @Prop({ default: "OK" }) buttonOk!: string
  @Prop({ required: true }) okAction!: Function

  @Prop({ default: "キャンセル" }) buttonCancel!: string
  @Prop({ default: null }) cancelAction!: Function|null

  private showmodal = false

  created() {
    this.$mount()
    document.body.appendChild(this.$el)
    this.showmodal = true
  }

  close() {
    this.showmodal = false
    this.$nextTick(() => {
      if (document.body.contains(this.$el)) {
        document.body.removeChild(this.$el)
        this.$destroy()
      }
    })
  }

  ok() {
    this.okAction()
    this.close()
  }
  cancel() {
    if (this.cancelAction != null) {
      this.cancelAction()
    }
    this.close()
  }
}
